import React from 'react';

import get from 'lodash.get';

import CInputField from '../../formElements/cInputField';

import { getSearchString } from '../formBuilderAnswersHelper';

import { addresFields, addressFieldsValidation } from '../../../../constants/formbuilder';

class AddressManualInputs extends React.Component {
    onChange = (path, value) => {
        const newValue = {
            ...this.props.value,
            [path]: value
        };

        const searchString = getSearchString(newValue);

        this.props.onChange({
            ...newValue,
            searchString: searchString
        });
    }

    render() {
        const { validation, value } = this.props;
        
        return (
            <div>
                <CInputField validation={{ ...validation, ...addressFieldsValidation[addresFields.STREET] }}
                    label="Street"
                    name="street"
                    autoComplete="address-line1"
                    onChange={(event, { value }) => this.onChange(addresFields.STREET, value)}
                    value={get(value, addresFields.STREET)} />

                <CInputField validation={{ ...validation, ...addressFieldsValidation[addresFields.SUBURB] }}
                    label="Suburb"
                    name="suburb"
                    autoComplete="address-level2"
                    onChange={(event, { value }) => this.onChange(addresFields.SUBURB, value)}
                    value={get(value, addresFields.SUBURB)} />

                <CInputField validation={{ ...validation, ...addressFieldsValidation[addresFields.STATE] }}
                    label="State"
                    name="state"
                    autoComplete="address-level1"
                    onChange={(event, { value }) => this.onChange(addresFields.STATE, value)}
                    value={get(value, addresFields.STATE)} />

                <CInputField validation={{ ...validation, ...addressFieldsValidation[addresFields.POSTCODE] }}
                    label="Post code"
                    name="postcode"
                    autoComplete="postal-code"
                    onChange={(event, { value }) => this.onChange(addresFields.POSTCODE, value)}
                    value={get(value, addresFields.POSTCODE)} />

                <CInputField validation={{ ...validation, ...addressFieldsValidation[addresFields.COUNTRY] }}
                    label="Country"
                    name="country"
                    autoComplete="country-name"
                    onChange={(event, { value }) => this.onChange(addresFields.COUNTRY, value)}
                    value={get(value, addresFields.COUNTRY)} />
            </div>
        );
    }
}

export default AddressManualInputs;
